<script>


    import { onMount, getContext } from "svelte";
import LoggedIn from "../Components/Auth/LoggedIn.svelte";
    import Date from "../Components/Helpers/date.svelte";
    import Popup from "../Components/Modal/Popup.svelte";
    import { options } from "../config";
    import { loading } from "../loader";
    import { PostContact } from "../Services/form0";
import { message_ } from "../Services/messages";
    import { user } from "../store";

    const { open } = getContext("simple-modal");
    var list = [];

    onMount(() => {
        loading.set(true);
        PostContact(
            { form: "internal/compliance/list", profile: options.profile },
            $user.idToken,
            (data) => {
                list = data.app_metadata.list;
                loading.set(false);
            },(error)=>{
                message_.set("You broke something")
                console.log(error)
                loading.set(false)
            }
        );
    });

    const show = (header,data) => {
        open(Popup, { header:header,html: data });
    };

    const openImage=(e,image)=>{
        PostContact({
            "form":"internal/compliance/image",profile:options.profile,id:e,image
        },$user.idToken,
        (data) => {
            const t = list.find(g=>g.Key===e)
            switch(image){
                case "antivirus":
                    t.data.cylance = data.cylance
                    break;
                case "encryption":
                    t.data.filevault2 = data.filevault2
                    break;
                default:
                    break;
            }
            list = [...list]
        },(error)=>{
                message_.set("You broke something")
                console.log(error)
                loading.set(false)
            }
        )
    }
</script>
<LoggedIn/>
<div class="section_wrapper">
    <div class="s s100">
        <div class="s s100 box">
            <div class="content_area">
                <h1>Compliance List</h1>
                <table class="form_table">
                    <thead>
                        <tr>
                            <th>Member</th>
                            <th>Date</th>
                            <th>Policies & Procedures Understood</th>
                            <th>Anti Virus</th>
                            <th>Encryption</th>
                            <th>Quad9</th>
                        </tr>
                    </thead> 
                    <tbody>
                        {#each list as l, i}
                            <tr>
                                <td>
                                    {#if l.editable}
                                    <a href="#/compliance/checklist/{l.Key}" class="linkbox"><i class="fad fa-edit"></i></a>
                                    {/if}
                                    {l.data.user.email}</td>
                                <td>
                                    <Date date={l.data.submitted} />
                                </td>
                                <td>{#if l.data.procedures}Yes{:else}No{/if}</td>
                                <td>
                                    {#if l.data.cylance || l.data.wav}
                                    <a class="linkbox blue" on:click={() => show("Antivirus",l.data.cylance || l.data.wav)}>View Screenshot</a>
                                    {:else}
                                    <a class="linkbox blue" on:click={()=> openImage(l.Key,"antivirus")}>Load Image</a>
                                    {/if}
                                </td>
                                <td>
                                    {#if l.data.filevault2 || l.data.bitlocker}
                                    <a class="linkbox blue" on:click={() => show("Encryption",l.data.filevault2 || l.data.bitlocker)}>View Screenshot</a>
                                    {:else}
                                    <a class="linkbox blue" on:click={()=> openImage(l.Key,"encryption")}>Load Image</a>
                                    {/if}
                                </td>
                                <td>
                                    {#if l.data.quad9}
                                    <a class="linkbox blue" on:click={() => show("DNS",l.data.quad9)}>View Screenshot</a>
                                    {:else}
                                    <a class="linkbox blue" on:click={()=> openImage(l.Key,"quad9")}>Load Image</a>
                                    {/if}
                                </td>
                            </tr>
                            {#if l.data.assets}
                                <tr> 
                                    <th class='text_right'>Assets</th>
                                    <th>Serial Number</th>
                                    <th>Description</th>
                                    <th>Location</th>
                                    <th>Owner</th>
                                    <th>Tag</th>
                                </tr>
                                {#each l.data.assets as a}
                                    {#if a.serial_number}
                                    <tr>
                                        <td />
                                        <td>{a.serial_number}</td>
                                        <td>{a.description}</td>
                                        <td>{a.location}</td>
                                        <td>{a.owner}</td>
                                        <td>{a.sticker??""}</td>
                                    </tr>
                                    {/if}
                                {/each}
                            {/if}
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
